import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import UserProp from './propTypes/userProp';
import BillingProp from './propTypes/billingProp';
import SidePanel from './sidePanel/SidePanel';
import MainPanel from './mainPanel/MainPanel';
import translate from '../../commonComponents/translate';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import { PROFILE_TABS } from '../../services/utilityFunctions';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import TaxIdTypeProp from '../subscriptionDetails/propTypes/TaxIdTypeProp';
import BusinessTypeProp from './propTypes/businessTypeProp';

/**
 * User profile main page
 */
class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      avatar: { ...props.member.image },
      billing: {
        billingAddress: { ...props.billing.billingAddress },
        businessType: props.billing.businessType || '',
        invoiceEmail: props.billing.invoiceEmail || '',
        taxId: props.billing.taxId || '',
        taxCode: props.billing.taxCode || '',
        taxType: props.billing.taxType || '',
        billingLanguage: props.billing.billingLanguage || '',
      },
      member: { ...props.member },
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(field) {
    return value => this.setState({ [field]: value });
  }

  render() {
    const { t, activeTab, countries, taxIdTypes, businessTypes, languages } =
      this.props;
    const { avatar, billing, member } = this.state;

    return (
      <DocumentTitle title={t('profile_head_title')}>
        <ContentContainer>
          <div id="profile_container" className="m-content">
            <div className="row">
              <div className="col-lg-4">
                <SidePanel
                  name={member.name}
                  email={member.email}
                  avatarURL={avatar.url}
                />
              </div>
              <div className="col-lg-8">
                <MainPanel
                  activeTab={activeTab}
                  member={member}
                  billing={billing}
                  onBillingChange={this.handleChange('billing')}
                  countries={countries}
                  taxIdTypes={taxIdTypes}
                  businessTypes={businessTypes}
                  languages={languages}
                />
              </div>
            </div>
          </div>
        </ContentContainer>
      </DocumentTitle>
    );
  }
}

Profile.propTypes = {
  t: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  activeTab: PropTypes.oneOf(PROFILE_TABS),
  member: PropTypes.shape(UserProp.propType).isRequired,
  billing: PropTypes.shape(BillingProp.propType).isRequired,
  taxIdTypes: PropTypes.arrayOf(PropTypes.shape(TaxIdTypeProp.propType))
    .isRequired,
  businessTypes: PropTypes.arrayOf(PropTypes.shape(BusinessTypeProp.propType))
    .isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
};

Profile.defaultProps = {
  activeTab: null,
};

export default translate(Profile);
